const isExistingOnboardingEntry = (questionnaireData) => {
  // Handle legacy questions - allow user to view everything

  if (
    !questionnaireData.data ||
    questionnaireData.data.length <= 0 ||
    questionnaireData.data[0] === false ||
    questionnaireData.data[0].questionnaire === null
  ) {
    return false;
  }
  return true;
};

const hasLegacyOnboardingData = (questionnaireData) => {
  if (
    questionnaireData.data &&
    questionnaireData.data.length > 0 &&
    questionnaireData.data[0].legacyQuestionnaire !== null
  ) {
    return true;
  }

  return false;
};

export { isExistingOnboardingEntry, hasLegacyOnboardingData };
